var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page",
    transform: "translate(-681, -6763)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0, 6401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(627, 362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_linkedin",
    transform: "translate(54, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56551283,1.66624741 C-0.315068752,3.61923571 0.069822282,5.69384962 0.069822282,11.9964489 C0.069822282,17.2303379 -0.843546078,22.477187 3.9366809,23.7123849 C5.42938007,24.0962034 18.655273,24.0962034 20.1459779,23.710391 C22.1362435,23.1969714 23.7555778,21.5829397 23.97694,18.7686028 C24.0078509,18.3758119 24.0078509,5.62406443 23.9759428,5.22329807 C23.7406208,2.22552583 21.8949387,0.497843994 19.4629459,0.147921129 C18.9055519,0.0671696985 18.7938737,0.0432433488 15.9341133,0.0382586926 C5.79034005,0.0432433488 3.56674678,-0.408366503 1.56551283,1.66624741 Z",
    id: "Path",
    fill: "#3414FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.5545, 4.5)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09090909,2.04545455 C4.09090909,3.1751279 3.1751279,4.09090909 2.04545455,4.09090909 C0.915781194,4.09090909 0,3.1751279 0,2.04545455 C0,0.915781194 0.915781194,0 2.04545455,0 C3.1751279,0 4.09090909,0.915781194 4.09090909,2.04545455 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62728009,5.45454545 L3.62728009,14.4913636 C3.6279986,14.626011 3.57501823,14.7553927 3.48006308,14.8508597 C3.38510794,14.9463268 3.25601294,15.0000018 3.12136364,15.0000018 L0.965454545,15.0000018 C0.83080637,15.0003634 0.701568302,14.9470355 0.606357317,14.8518245 C0.511146333,14.7566135 0.457818393,14.6273754 0.458179973,14.4927273 L0.458179973,5.45454545 C0.458179973,5.17438646 0.685295554,4.94727273 0.965454545,4.94727273 L3.12136364,4.94727273 C3.40098995,4.94802441 3.62728009,5.17491813 3.62728009,5.45454545 L3.62728009,5.45454545 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8963656,10.1590909 L14.8963656,14.5336364 C14.8967272,14.6574348 14.8477094,14.7762676 14.7601703,14.8638067 C14.6726312,14.9513457 14.5537984,15.0003636 14.43,15.000002 L12.1118182,15.000002 C11.9880198,15.0003636 11.869187,14.9513457 11.7816479,14.8638067 C11.6941088,14.7762676 11.645091,14.6574348 11.6454545,14.5336364 L11.6454545,10.2940909 C11.6454545,9.66136364 11.8309091,7.52318182 9.99136364,7.52318182 C8.56636364,7.52318182 8.27590909,8.98636364 8.21863636,9.64363636 L8.21863636,14.5336364 C8.21866361,14.7885625 8.01398985,14.996273 7.75909091,15.000002 L5.52,15.000002 C5.3964377,15.000002 5.27795601,14.9508225 5.19071229,14.8633229 C5.10346857,14.7758233 5.05463765,14.6571981 5.054998,14.5336364 L5.054998,5.415 C5.05463765,5.29143823 5.10346857,5.17281304 5.19071229,5.08531347 C5.27795601,4.99781391 5.3964377,4.94863583 5.52,4.94863636 L7.75909091,4.94863636 C8.01665643,4.94863636 8.22545455,5.15743448 8.22545455,5.415 L8.22545455,6.20318182 C8.75454545,5.40954545 9.53863636,4.79727273 11.2118182,4.79727273 C14.9181818,4.79727273 14.8963656,8.25818182 14.8963656,10.1590909 L14.8963656,10.1590909 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.1be1d49e053f63e123055723a0a65f0a.svg";
export { ForwardRef as ReactComponent };